export const enablePreview = (slug: string) =>
  `/api/preview?slug=/${encodeURI(slug)}`;

export const disablePreview = (slug: string) =>
  `/api/preview/exit/?slug=${encodeURI(slug)}`;
